import * as actions from '../actions';

import fetchJoinUrlReducer from './fetchJoinUrl.app.reducer';

const initialState = {
  fetchingJoinUrl: false,
};

const reducerMap = {
  [actions.BBB_GET_JOIN_URL]: fetchJoinUrlReducer,
};

export default (state = initialState, action) => {
  const reducer = reducerMap[action.type];
  if (typeof reducer === 'undefined') return state;
  return reducer(state, action);
};
